export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'

export const O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST'
export const O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS'
export const O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE'

export const O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST'
export const O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS'
export const O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE'

export const O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST'
export const O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS'
export const O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE'

export const O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST'
export const O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS'
export const O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE'

export const O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST'
export const O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS'
export const O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE'

export const O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST'
export const O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS'
export const O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE'

export const O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST'
export const O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS'
export const O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE'

export const O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST'
export const O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS'
export const O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE'

export const BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST'
export const BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS'
export const BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE'

export const O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST'
export const O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS'
export const O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE'

export const O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST'
export const O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS'
export const O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE'

export const O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST'
export const O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS'
export const O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE'

export const CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST'
export const CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS'
export const CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE'

export const CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST'
export const CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS'
export const CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE'

export const CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT'

export const CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST'
export const CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS'
export const CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE'

export const CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST'
export const CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS'
export const CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE'

export const CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST'
export const CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS'
export const CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE'

export const O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST'
export const O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS'
export const O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE'

export const O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST'
export const O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS'
export const O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE'

export const O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST'
export const O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS'
export const O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE'

export const O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST'
export const O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS'
export const O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE'

export const CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID'
export const CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT'

export const CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST'
export const CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS'
export const CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE'

export const CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST'
export const CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS'
export const CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE'

export const CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST'
export const CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS'
export const CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE'

export const CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST'
export const CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS'
export const CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE'

export const CORE_LOAD_CONTACT_REQUEST = 'CORE_LOAD_CONTACT_REQUEST'
export const CORE_LOAD_CONTACT_SUCCESS = 'CORE_LOAD_CONTACT_SUCCESS'
export const CORE_LOAD_CONTACT_FAILURE = 'CORE_LOAD_CONTACT_FAILURE'

export const CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST'
export const CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS'
export const CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE'

export const CORE_LOAD_INTEGRATION_REQUEST = 'CORE_LOAD_INTEGRATION_REQUEST'
export const CORE_LOAD_INTEGRATION_SUCCESS = 'CORE_LOAD_INTEGRATION_SUCCESS'
export const CORE_LOAD_INTEGRATION_FAILURE = 'CORE_LOAD_INTEGRATION_FAILURE'

export const CORE_USER_INTEGRATION_REQUEST = 'CORE_USER_INTEGRATION_REQUEST'
export const CORE_USER_INTEGRATION_SUCCESS = 'CORE_USER_INTEGRATION_SUCCESS'
export const CORE_USER_INTEGRATION_FAILURE = 'CORE_USER_INTEGRATION_FAILURE'

export const CORE_REMOVE_INTEGRATION_REQUEST = 'CORE_REMOVE_INTEGRATION_REQUEST'
export const CORE_REMOVE_INTEGRATION_SUCCESS = 'CORE_REMOVE_INTEGRATION_SUCCESS'
export const CORE_REMOVE_INTEGRATION_FAILURE = 'CORE_REMOVE_INTEGRATION_FAILURE'

export const CORE_SEARCH_ROOM_REQUEST = 'CORE_SEARCH_ROOM_REQUEST'
export const CORE_SEARCH_ROOM_SUCCESS = 'CORE_SEARCH_ROOM_SUCCESS'
export const CORE_SEARCH_ROOM_FAILURE = 'CORE_SEARCH_ROOM_FAILURE'

export const CORE_LOAD_O365URL_REQUEST = 'CORE_LOAD_O365URL_REQUEST'
export const CORE_LOAD_O365URL_SUCCESS = 'CORE_LOAD_O365URL_SUCCESS'
export const CORE_LOAD_O365URL_FAILURE = 'CORE_LOAD_O365URL_FAILURE'

export const O365_LOAD_EVENTLIST_REQUEST = 'O365_LOAD_EVENTLIST_REQUEST'
export const O365_LOAD_EVENTLIST_SUCCESS = 'O365_LOAD_EVENTLIST_SUCCESS'
export const O365_LOAD_EVENTLIST_FAILURE = 'O365_LOAD_EVENTLIST_FAILURE'

export const O365_LOAD_EVENTDETAIL_REQUEST = 'O365_LOAD_EVENTDETAIL_REQUEST'
export const O365_LOAD_EVENTDETAIL_SUCCESS = 'O365_LOAD_EVENTDETAIL_SUCCESS'
export const O365_LOAD_EVENTDETAIL_FAILURE = 'O365_LOAD_EVENTDETAIL_FAILURE'

export const O365_SUGGEST_ROOM_REQUEST = 'O365_SUGGEST_ROOM_REQUEST'
export const O365_SUGGEST_ROOM_SUCCESS = 'O365_SUGGEST_ROOM_SUCCESS'
export const O365_SUGGEST_ROOM_FAILURE = 'O365_SUGGEST_ROOM_FAILURE'

export const O365_SUGGESTTION_REQUEST = 'O365_SUGGESTTION_REQUEST'
export const O365_SUGGESTTION_SUCCESS = 'O365_SUGGESTTION_SUCCESS'
export const O365_SUGGESTTION_FAILURE = 'O365_SUGGESTTION_FAILURE'

export const CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST'
export const CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS'
export const CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE'

export const O365_USER_LIST_REQUEST = 'O365_USER_LIST_REQUEST'
export const O365_USER_LIST_SUCCESS = 'O365_USER_LIST_SUCCESS'
export const O365_USER_LIST_FAILURE = 'O365_USER_LIST_FAILURE'

export const CORE_GET_ROOM_INFO_REQUEST = 'CORE_GET_ROOM_INFO_REQUEST'
export const CORE_GET_ROOM_INFO_SUCCESS = 'CORE_GET_ROOM_INFO_SUCCESS'
export const CORE_GET_ROOM_INFO_FAILURE = 'CORE_GET_ROOM_INFO_FAILURE'

export const CORE_GET_ROOM_STATUS_REQUEST = 'CORE_GET_ROOM_STATUS_REQUEST'
export const CORE_GET_ROOM_STATUS_SUCCESS = 'CORE_GET_ROOM_STATUS_SUCCESS'
export const CORE_GET_ROOM_STATUS_FAILURE = 'CORE_GET_ROOM_STATUS_FAILURE'

export const SERVICE_SEARCH_USERS_REQUEST = 'SERVICE_SEARCH_USERS_REQUEST'
export const SERVICE_SEARCH_USERS_SUCCESS = 'SERVICE_SEARCH_USERS_SUCCESS'
export const SERVICE_SEARCH_USERS_FAILURE = 'SERVICE_SEARCH_USERS_FAILURE'

export const CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST'
export const CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS'
export const CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE'

export const O365_CHECKOUT_REQUEST = 'O365_CHECKOUT_REQUEST'
export const O365_CHECKOUT_SUCCESS = 'O365_CHECKOUT_SUCCESS'
export const O365_CHECKOUT_FAILURE = 'O365_CHECKOUT_FAILURE'

export const SERVICE_DELETE_EVENT_REQUEST = 'SERVICE_DELETE_EVENT_REQUEST'
export const SERVICE_DELETE_EVENT_SUCCESS = 'SERVICE_DELETE_EVENT_SUCCESS'
export const SERVICE_DELETE_EVENT_FAILURE = 'SERVICE_DELETE_EVENT_FAILURE'

export const SERVICE_ACCEPT_EVENT_REQUEST = 'SERVICE_ACCEPT_EVENT_REQUEST'
export const SERVICE_ACCEPT_EVENT_SUCCESS = 'SERVICE_ACCEPT_EVENT_SUCCESS'
export const SERVICE_ACCEPT_EVENT_FAILURE = 'SERVICE_ACCEPT_EVENT_FAILURE'

export const SERVICE_DECILNE_EVENT_REQUEST = 'SERVICE_DECILNE_EVENT_REQUEST'
export const SERVICE_DECILNE_EVENT_SUCCESS = 'SERVICE_DECILNE_EVENT_SUCCESS'
export const SERVICE_DECILNE_EVENT_FAILURE = 'SERVICE_DECILNE_EVENT_FAILURE'

export const SERVICE_TENTATIVELY_EVENT_REQUEST = 'SERVICE_TENTATIVELY_EVENT_REQUEST'
export const SERVICE_TENTATIVELY_EVENT_SUCCESS = 'SERVICE_TENTATIVELY_EVENT_SUCCESS'
export const SERVICE_TENTATIVELY_EVENT_FAILURE = 'SERVICE_TENTATIVELY_EVENT_FAILURE'

export const CORE_LOAD_FBS_REQUEST = 'CORE_LOAD_FBS_REQUEST'
export const CORE_LOAD_FBS_SUCCESS = 'CORE_LOAD_FBS_SUCCESS'
export const CORE_LOAD_FBS_FAILURE = 'CORE_LOAD_FBS_FAILURE'

export const CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST'
export const CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS'
export const CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE'

export const CORE_LOAD_FOODACTIVE_REQUEST = 'CORE_LOAD_FOODACTIVE_REQUEST'
export const CORE_LOAD_FOODACTIVE_SUCCESS = 'CORE_LOAD_FOODACTIVE_SUCCESS'
export const CORE_LOAD_FOODACTIVE_FAILURE = 'CORE_LOAD_FOODACTIVE_FAILURE'

export const CORE_LOAD_FOODPAST_REQUEST = 'CORE_LOAD_FOODPAST_REQUEST'
export const CORE_LOAD_FOODPAST_SUCCESS = 'CORE_LOAD_FOODPAST_SUCCESS'
export const CORE_LOAD_FOODPAST_FAILURE = 'CORE_LOAD_FOODPAST_FAILURE'

export const CORE_LOAD_EVENTSERVICEFBS_REQUEST = 'CORE_LOAD_EVENTSERVICEFBS_REQUEST'
export const CORE_LOAD_EVENTSERVICEFBS_SUCCESS = 'CORE_LOAD_EVENTSERVICEFBS_SUCCESS'
export const CORE_LOAD_EVENTSERVICEFBS_FAILURE = 'CORE_LOAD_EVENTSERVICEFBS_FAILURE'

export const CORE_LOAD_EVENTINFOSERVICE_REQUEST = 'CORE_LOAD_EVENTINFOSERVICE_REQUEST'
export const CORE_LOAD_EVENTINFOSERVICE_SUCCESS = 'CORE_LOAD_EVENTINFOSERVICE_SUCCESS'
export const CORE_LOAD_EVENTINFOSERVICE_FAILURE = 'CORE_LOAD_EVENTINFOSERVICE_FAILURE'

export const CORE_SENDFOOD_REQUEST = 'CORE_SENDFOOD_REQUEST'
export const CORE_SENDFOOD_SUCCESS = 'CORE_SENDFOOD_SUCCESS'
export const CORE_SENDFOOD_FAILURE = 'CORE_SENDFOOD_FAILURE'

export const CORE_DONEFOOD_REQUEST = 'CORE_DONEFOOD_REQUEST'
export const CORE_DONEFOOD_SUCCESS = 'CORE_DONEFOOD_SUCCESS'
export const CORE_DONEFOOD_FAILURE = 'CORE_DONEFOOD_FAILURE'

export const CORE_LOAD_EVENTS_REQUEST = 'CORE_LOAD_EVENTS_REQUEST'
export const CORE_LOAD_EVENTS_SUCCESS = 'CORE_LOAD_EVENTS_SUCCESS'
export const CORE_LOAD_EVENTS_FAILURE = 'CORE_LOAD_EVENTS_FAILURE'

export const CORE_UPDATE_ORDER_REQUEST = 'CORE_UPDATE_ORDER_REQUEST'
export const CORE_UPDATE_ORDER_SUCCESS = 'CORE_UPDATE_ORDER_SUCCESS'
export const CORE_UPDATE_ORDER_FAILURE = 'CORE_UPDATE_ORDER_FAILURE'

export const CORE_LOAD_ORDERS_EVENT_REQUEST = 'CORE_LOAD_ORDERS_EVENT_REQUEST'
export const CORE_LOAD_ORDERS_EVENT_SUCCESS = 'CORE_LOAD_ORDERS_EVENT_SUCCESS'
export const CORE_LOAD_ORDERS_EVENT_FAILURE = 'CORE_LOAD_ORDERS_EVENT_FAILURE'

export const O365_LOAD_EVENTLIST_BETWEEN_REQUEST = 'O365_LOAD_EVENTLIST_BETWEEN_REQUEST'
export const O365_LOAD_EVENTLIST_BETWEEN_SUCCESS = 'O365_LOAD_EVENTLIST_BETWEEN_SUCCESS'
export const O365_LOAD_EVENTLIST_BETWEEN_FAILURE = 'O365_LOAD_EVENTLIST_BETWEEN_FAILURE'

export const CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST'
export const CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS'
export const CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE'

export const O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST = 'O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST'
export const O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS = 'O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS'
export const O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE = 'O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE'

export const CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST'
export const CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS'
export const CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE'

export const CORE_UPDATE_TIMEZONE_REQUEST = 'CORE_UPDATE_TIMEZONE_REQUEST'
export const CORE_UPDATE_TIMEZONE_SUCCESS = 'CORE_UPDATE_TIMEZONE_SUCCESS'
export const CORE_UPDATE_TIMEZONE_FAILURE = 'CORE_UPDATE_TIMEZONE_FAILURE'

export const CORE_LOAD_FOODNEXT_REQUEST = 'CORE_LOAD_FOODNEXT_REQUEST'
export const CORE_LOAD_FOODNEXT_SUCCESS = 'CORE_LOAD_FOODNEXT_SUCCESS'
export const CORE_LOAD_FOODNEXT_FAILURE = 'CORE_LOAD_FOODNEXT_FAILURE'

export const CORE_CANCELEVENTFOOD_REQUEST = 'CORE_CANCELEVENTFOOD_REQUEST'
export const CORE_CANCELEVENTFOOD_SUCCESS = 'CORE_CANCELEVENTFOOD_SUCCESS'
export const CORE_CANCELEVENTFOOD_FAILURE = 'CORE_CANCELEVENTFOOD_FAILURE'

export const CORE_LOAD_AMENITYNEXT_REQUEST = 'CORE_LOAD_AMENITYNEXT_REQUEST'
export const CORE_LOAD_AMENITYNEXT_SUCCESS = 'CORE_LOAD_AMENITYNEXT_SUCCESS'
export const CORE_LOAD_AMENITYNEXT_FAILURE = 'CORE_LOAD_AMENITYNEXT_FAILURE'

export const CORE_DONEAMENITY_REQUEST = 'CORE_DONEAMENITY_REQUEST'
export const CORE_DONEAMENITY_FAILURE = 'CORE_DONEAMENITY_FAILURE'
export const CORE_DONEAMENITY_SUCCESS = 'CORE_DONEAMENITY_SUCCESS'

export const CORE_CANCELEVENTAMENITY_REQUEST = 'CORE_CANCELEVENTAMENITY_REQUEST'
export const CORE_CANCELEVENTAMENITY_SUCCESS = 'CORE_CANCELEVENTAMENITY_SUCCESS'
export const CORE_CANCELEVENTAMENITY_FAILURE = 'CORE_CANCELEVENTAMENITY_FAILURE'

export const CORE_SENDAMENITY_REQUEST = 'CORE_SENDAMENITY_REQUEST'
export const CORE_SENDAMENITY_SUCCESS = 'CORE_SENDAMENITY_SUCCESS'
export const CORE_SENDAMENITY_FAILURE = 'CORE_SENDAMENITY_FAILURE'

export const CORE_LOAD_AMENITYPAST_REQUEST = 'CORE_LOAD_AMENITYPAST_REQUEST'
export const CORE_LOAD_AMENITYPAST_SUCCESS = 'CORE_LOAD_AMENITYPAST_SUCCESS'
export const CORE_LOAD_AMENITYPAST_FAILURE = 'CORE_LOAD_AMENITYPAST_FAILURE'

export const CORE_LOAD_EVENTSERVICEAMENITY_REQUEST = 'CORE_LOAD_EVENTSERVICEAMENITY_REQUEST'
export const CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS = 'CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS'
export const CORE_LOAD_EVENTSERVICEAMENITY_FAILURE = 'CORE_LOAD_EVENTSERVICEAMENITY_FAILURE'

export const CORE_LOAD_AMENITYACTIVE_REQUEST = 'CORE_LOAD_AMENITYACTIVE_REQUEST'
export const CORE_LOAD_AMENITYACTIVE_SUCCESS = 'CORE_LOAD_AMENITYACTIVE_SUCCESS'
export const CORE_LOAD_AMENITYACTIVE_FAILURE = 'CORE_LOAD_AMENITYACTIVE_FAILURE'

export const CORE_LOAD_SUGGEST_INFORMATION_REQUEST = 'CORE_LOAD_SUGGEST_INFORMATION_REQUEST'
export const CORE_LOAD_SUGGEST_INFORMATION_SUCCESS = 'CORE_LOAD_SUGGEST_INFORMATION_SUCCESS'
export const CORE_LOAD_SUGGEST_INFORMATION_FAILURE = 'CORE_LOAD_SUGGEST_INFORMATION_FAILURE'

export const CORE_LOAD_EVENTHOME_REQUEST = 'CORE_LOAD_EVENTHOME_REQUEST'
export const CORE_LOAD_EVENTHOME_SUCCESS = 'CORE_LOAD_EVENTHOME_SUCCESS'
export const CORE_LOAD_EVENTHOME_FAILURE = 'CORE_LOAD_EVENTHOME_FAILURE'

export const CORE_GET_FAVORITEROOM_REQUEST = 'CORE_GET_FAVORITEROOM_REQUEST'
export const CORE_GET_FAVORITEROOM_SUCCESS = 'CORE_GET_FAVORITEROOM_SUCCESS'
export const CORE_GET_FAVORITEROOM_FAILURE = 'CORE_GET_FAVORITEROOM_FAILURE'

export const CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST'
export const CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS'
export const CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE'

export const CORE_INTEGRATION_EXCHANGE_REQUEST = 'CORE_INTEGRATION_EXCHANGE_REQUEST'
export const CORE_INTEGRATION_EXCHANGE_SUCCESS = 'CORE_INTEGRATION_EXCHANGE_SUCCESS'
export const CORE_INTEGRATION_EXCHANGE_FAILURE = 'CORE_INTEGRATION_EXCHANGE_FAILURE'

export const CORE_GETURL_GOOGLE_REQUEST = 'CORE_GETURL_GOOGLE_REQUEST'
export const CORE_GETURL_GOOGLE_SUCCESS = 'CORE_GETURL_GOOGLE_SUCCESS'
export const CORE_GETURL_GOOGLE_FAILURE = 'CORE_GETURL_GOOGLE_FAILURE'

export const CORE_INTEGRATION_GOOGLE_REQUEST = 'CORE_INTEGRATION_GOOGLE_REQUEST'
export const CORE_INTEGRATION_GOOGLE_SUCCESS = 'CORE_INTEGRATION_GOOGLE_SUCCESS'
export const CORE_INTEGRATION_GOOGLE_FAILURE = 'CORE_INTEGRATION_GOOGLE_FAILURE'

export const CORE_GET_FAVORITESEAT_REQUEST = 'CORE_GET_FAVORITESEAT_REQUEST'
export const CORE_GET_FAVORITESEAT_SUCCESS = 'CORE_GET_FAVORITESEAT_SUCCESS'
export const CORE_GET_FAVORITESEAT_FAILURE = 'CORE_GET_FAVORITESEAT_FAILURE'

export const CORE_LOAD_ALL_BUILDING_REQUEST = 'CORE_LOAD_ALL_BUILDING_REQUEST'
export const CORE_LOAD_ALL_BUILDING_SUCCESS = 'CORE_LOAD_ALL_BUILDING_SUCCESS'
export const CORE_LOAD_ALL_BUILDING_FAILURE = 'CORE_LOAD_ALL_BUILDING_FAILURE'

export const CORE_LOAD_ALL_FLOOR_REQUEST = 'CORE_LOAD_ALL_FLOOR_REQUEST'
export const CORE_LOAD_ALL_FLOOR_SUCCESS = 'CORE_LOAD_ALL_FLOOR_SUCCESS'
export const CORE_LOAD_ALL_FLOOR_FAILURE = 'CORE_LOAD_ALL_FLOOR_FAILURE'

export const CORE_LOAD_ALL_ZONE_REQUEST = 'CORE_LOAD_ALL_ZONE_REQUEST'
export const CORE_LOAD_ALL_ZONE_SUCCESS = 'CORE_LOAD_ALL_ZONE_SUCCESS'
export const CORE_LOAD_ALL_ZONE_FAILURE = 'CORE_LOAD_ALL_ZONE_FAILURE'

export const CORE_SUGGEST_SEAT_REQUEST = 'CORE_SUGGEST_SEAT_REQUEST'
export const CORE_SUGGEST_SEAT_SUCCESS = 'CORE_SUGGEST_SEAT_SUCCESS'
export const CORE_SUGGEST_SEAT_FAILURE = 'CORE_SUGGEST_SEAT_FAILURE'

export const CORE_CREATE_EVENT_SEAT_REQUEST = 'CORE_CREATE_EVENT_SEAT_REQUEST'
export const CORE_CREATE_EVENT_SEAT_SUCCESS = 'CORE_CREATE_EVENT_SEAT_SUCCESS'
export const CORE_CREATE_EVENT_SEAT_FAILURE = 'CORE_CREATE_EVENT_SEAT_FAILURE'

export const CORE_DELETE_EVENT_SEAT_REQUEST = 'CORE_DELETE_EVENT_SEAT_REQUEST'
export const CORE_DELETE_EVENT_SEAT_SUCCESS = 'CORE_DELETE_EVENT_SEAT_SUCCESS'
export const CORE_DELETE_EVENT_SEAT_FAILURE = 'CORE_DELETE_EVENT_SEAT_FAILURE'

export const CORE_GET_EVENT_SEATGROUP_REQUEST = 'CORE_GET_EVENT_SEATGROUP_REQUEST'
export const CORE_GET_EVENT_SEATGROUP_SUCCESS = 'CORE_GET_EVENT_SEATGROUP_SUCCESS'
export const CORE_GET_EVENT_SEATGROUP_FAILURE = 'CORE_GET_EVENT_SEATGROUP_FAILURE'

export const CORE_GET_MYEVENT_SEATBYDATE_REQUEST = 'CORE_GET_MYEVENT_SEATBYDATE_REQUEST'
export const CORE_GET_MYEVENT_SEATBYDATE_SUCCESS = 'CORE_GET_MYEVENT_SEATBYDATE_SUCCESS'
export const CORE_GET_MYEVENT_SEATBYDATE_FAILURE = 'CORE_GET_MYEVENT_SEATBYDATE_FAILURE'

export const O365_SUGGEST_ROOM_MEETING_REQUEST = 'O365_SUGGEST_ROOM_MEETING_REQUEST'
export const O365_SUGGEST_ROOM_MEETING_SUCCESS = 'O365_SUGGEST_ROOM_MEETING_SUCCESS'
export const O365_SUGGEST_ROOM_MEETING_FAILURE = 'O365_SUGGEST_ROOM_MEETING_FAILURE'

export const CORE_ADD_FAVORITEROOM_REQUEST = 'CORE_ADD_FAVORITEROOM_REQUEST'
export const CORE_ADD_FAVORITEROOM_SUCCESS = 'CORE_ADD_FAVORITEROOM_SUCCESS'
export const CORE_ADD_FAVORITEROOM_FAILURE = 'CORE_ADD_FAVORITEROOM_FAILURE'

export const CORE_REMOVE_FAVORITEROOM_REQUEST = 'CORE_REMOVE_FAVORITEROOM_REQUEST'
export const CORE_REMOVE_FAVORITEROOM_SUCCESS = 'CORE_REMOVE_FAVORITEROOM_SUCCESS'
export const CORE_REMOVE_FAVORITEROOM_FAILURE = 'CORE_REMOVE_FAVORITEROOM_FAILURE'

export const CORE_LOAD_ALLFACILITIES_REQUEST = 'CORE_LOAD_ALLFACILITIES_REQUEST'
export const CORE_LOAD_ALLFACILITIES_SUCCESS = 'CORE_LOAD_ALLFACILITIES_SUCCESS'
export const CORE_LOAD_ALLFACILITIES_FAILURE = 'CORE_LOAD_ALLFACILITIES_FAILURE'

export const CORE_LOAD_ALLFOODANDBEV_REQUEST = 'CORE_LOAD_ALLFOODANDBEV_REQUEST'
export const CORE_LOAD_ALLFOODANDBEV_SUCCESS = 'CORE_LOAD_ALLFOODANDBEV_SUCCESS'
export const CORE_LOAD_ALLFOODANDBEV_FAILURE = 'CORE_LOAD_ALLFOODANDBEV_FAILURE'

export const CORE_CREATE_AMENITIES_REQUEST = 'CORE_CREATE_AMENITIES_REQUEST'
export const CORE_CREATE_AMENITIES_SUCCESS = 'CORE_CREATE_AMENITIES_SUCCESS'
export const CORE_CREATE_AMENITIES_FAILURE = 'CORE_CREATE_AMENITIES_FAILURE'

export const CORE_LOAD_ORDERAMENITIES_REQUEST = 'CORE_LOAD_ORDERAMENITIES_REQUEST'
export const CORE_LOAD_ORDERAMENITIES_SUCCESS = 'CORE_LOAD_ORDERAMENITIES_SUCCESS'
export const CORE_LOAD_ORDERAMENITIES_FAILURE = 'CORE_LOAD_ORDERAMENITIES_FAILURE'

export const CORE_CREATE_FOODANDBEV_REQUEST = 'CORE_CREATE_FOODANDBEV_REQUEST'
export const CORE_CREATE_FOODANDBEV_SUCCESS = 'CORE_CREATE_FOODANDBEV_SUCCESS'
export const CORE_CREATE_FOODANDBEV_FAILURE = 'CORE_CREATE_FOODANDBEV_FAILURE'

export const CORE_LOAD_ORDERFOODANDBEV_REQUEST = 'CORE_LOAD_ORDERFOODANDBEV_REQUEST'
export const CORE_LOAD_ORDERFOODANDBEV_SUCCESS = 'CORE_LOAD_ORDERFOODANDBEV_SUCCESS'
export const CORE_LOAD_ORDERFOODANDBEV_FAILURE = 'CORE_LOAD_ORDERFOODANDBEV_FAILURE'

export const CORE_LOAD_ORDERINFO_REQUEST = 'CORE_LOAD_ORDERINFO_REQUEST'
export const CORE_LOAD_ORDERINFO_SUCCESS = 'CORE_LOAD_ORDERINFO_SUCCESS'
export const CORE_LOAD_ORDERINFO_FAILURE = 'CORE_LOAD_ORDERINFO_FAILURE'

export const CORE_DELETE_ORDERAMENITY_REQUEST = 'CORE_DELETE_ORDERAMENITY_REQUEST'
export const CORE_DELETE_ORDERAMENITY_SUCCESS = 'CORE_DELETE_ORDERAMENITY_SUCCESS'
export const CORE_DELETE_ORDERAMENITY_FAILURE = 'CORE_DELETE_ORDERAMENITY_FAILURE'

export const CORE_DELETE_ORDERFOODANDBEV_REQUEST = 'CORE_DELETE_ORDERFOODANDBEV_REQUEST'
export const CORE_DELETE_ORDERFOODANDBEV_SUCCESS = 'CORE_DELETE_ORDERFOODANDBEV_SUCCESS'
export const CORE_DELETE_ORDERFOODANDBEV_FAILURE = 'CORE_DELETE_ORDERFOODANDBEV_FAILURE'

export const CORE_UPDATE_ORDERFOODANDBEV_SUCCESS = 'CORE_UPDATE_ORDERFOODANDBEV_REQUEST'
export const CORE_UPDATE_ORDERFOODANDBEV_REQUEST = 'CORE_UPDATE_ORDERFOODANDBEV_SUCCESS'
export const CORE_UPDATE_ORDERFACILITIES_REQUEST = 'CORE_UPDATE_ORDERFOODANDBEV_FAILURE'

export const CORE_UPDATE_ORDERFOODANDBEV_FAILURE = 'CORE_UPDATE_ORDERFACILITIES_REQUEST'
export const CORE_UPDATE_ORDERFACILITIES_FAILURE = 'CORE_UPDATE_ORDERFACILITIES_SUCCESS'
export const CORE_UPDATE_ORDERFACILITIES_SUCCESS = 'CORE_UPDATE_ORDERFACILITIES_FAILURE'

export const CORE_FORGOT_PASSWORD_REQUEST = 'CORE_FORGOT_PASSWORD_REQUEST'
export const CORE_FORGOT_PASSWORD_SUCCESS = 'CORE_FORGOT_PASSWORD_SUCCESS'
export const CORE_FORGOT_PASSWORD_FAILURE = 'CORE_FORGOT_PASSWORD_FAILURE'

export const CORE_CONFIRM_RESET_PASSWORD_REQUEST = 'CORE_CONFIRM_RESET_PASSWORD_REQUEST'
export const CORE_CONFIRM_RESET_PASSWORD_SUCCESS = 'CORE_CONFIRM_RESET_PASSWORD_SUCCESS'
export const CORE_CONFIRM_RESET_PASSWORD_FAILURE = 'CORE_CONFIRM_RESET_PASSWORD_FAILURE'

export const CORE_GET_CAN_BOOKING_REQUEST = 'CORE_GET_CAN_BOOKING_REQUEST'
export const CORE_GET_CAN_BOOKING_SUCCESS = 'CORE_GET_CAN_BOOKING_SUCCESS'
export const CORE_GET_CAN_BOOKING_FAILURE = 'CORE_GET_CAN_BOOKING_FAILURE'

export const CORE_GET_ROOMDISABLE_REQUEST = 'CORE_GET_ROOMDISABLE_REQUEST'
export const CORE_GET_ROOMDISABLE_SUCCESS = 'CORE_GET_ROOMDISABLE_SUCCESS'
export const CORE_GET_ROOMDISABLE_FAILURE = 'CORE_GET_ROOMDISABLE_FAILURE'

export const CORE_LOGOUT_REQUEST = 'CORE_LOGOUT_REQUEST'
export const CORE_LOGOUT_SUCCESS = 'CORE_LOGOUT_SUCCESS'
export const CORE_LOGOUT_FAILURE = 'CORE_LOGOUT_FAILURE'

export const CORE_LOAD_EVENT_TYPE_REQUEST = 'CORE_LOAD_EVENT_TYPE_REQUEST'
export const CORE_LOAD_EVENT_TYPE_SUCCESS = 'CORE_LOAD_EVENT_TYPE_SUCCESS'
export const CORE_LOAD_EVENT_TYPE_FAILURE = 'CORE_LOAD_EVENT_TYPE_FAILURE'

export const CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST'
export const CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS'
export const CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE'

export const CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST = 'CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST'
export const CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS = 'CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS'
export const CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE = 'CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE'

export const CORE_GET_CONFERENCE_TYPE_LIST_REQUEST = 'CORE_GET_CONFERENCE_TYPE_LIST_REQUEST'
export const CORE_GET_CONFERENCE_TYPE_LIST_SUCCESS = 'CORE_GET_CONFERENCE_TYPE_LIST_SUCCESS'
export const CORE_GET_CONFERENCE_TYPE_LIST_FAILURE = 'CORE_GET_CONFERENCE_TYPE_LIST_FAILURE'

export const CORE_LOAD_USER_GROUP_REQUEST = 'CORE_LOAD_USER_GROUP_REQUEST'
export const CORE_LOAD_USER_GROUP_SUCCESS = 'CORE_LOAD_USER_GROUP_SUCCESS'
export const CORE_LOAD_USER_GROUP_FAILURE = 'CORE_LOAD_USER_GROUP_FAILURE'

export const CORE_LOAD_GOOGLE_AUTHEN_REQUEST = 'CORE_LOAD_GOOGLE_AUTHEN_REQUEST'
export const CORE_LOAD_GOOGLE_AUTHEN_SUCCESS = 'CORE_LOAD_GOOGLE_AUTHEN_SUCCESS'
export const CORE_LOAD_GOOGLE_AUTHEN_FAILURE = 'CORE_LOAD_GOOGLE_AUTHEN_FAILURE'

export const CORE_AUTHEN_GOOGLE_REQUEST = 'CORE_AUTHEN_GOOGLE_REQUEST'
export const CORE_AUTHEN_GOOGLE_SUCCESS = 'CORE_AUTHEN_GOOGLE_SUCCESS'
export const CORE_AUTHEN_GOOGLE_FAILURE = 'CORE_AUTHEN_GOOGLE_FAILURE'

export const CORE_USER_AUTHEN_O365_REQUEST = 'CORE_USER_AUTHEN_O365_REQUEST'
export const CORE_USER_AUTHEN_O365_SUCCESS = 'CORE_USER_AUTHEN_O365_SUCCESS'
export const CORE_USER_AUTHEN_O365_FAILURE = 'CORE_USER_AUTHEN_O365_FAILURE'

export const CORE_LOAD_ATTENDEE_CHECKIN_REQUEST = "CORE_LOAD_ATTENDEE_CHECKIN_REQUEST"
export const CORE_LOAD_ATTENDEE_CHECKIN_SUCCESS = "CORE_LOAD_ATTENDEE_CHECKIN_SUCCESS"
export const CORE_LOAD_ATTENDEE_CHECKIN_FAILURE = "CORE_LOAD_ATTENDEE_CHECKIN_FAILURE"

export const SERVICE_SEARCH_USERS_WITH_KEYWORD_REQUEST = 'SERVICE_SEARCH_USERS_WITH_KEYWORD_REQUEST'
export const SERVICE_SEARCH_USERS_WITH_KEYWORD_SUCCESS = 'SERVICE_SEARCH_USERS_WITH_KEYWORD_SUCCESS'
export const SERVICE_SEARCH_USERS_WITH_KEYWORD_FAILURE = 'SERVICE_SEARCH_USERS_WITH_KEYWORD_FAILURE'

export const O365_RESEND_EVENT_PIN_REQUEST = 'O365_RESEND_EVENT_PIN_REQUEST'
export const O365_RESEND_EVENT_PIN_SUCCESS = 'O365_RESEND_EVENT_PIN_SUCCESS'
export const O365_RESEND_EVENT_PIN_FAILURE = 'O365_RESEND_EVENT_PIN_FAILURE'

export const SET_EVENT_DETAIL_MODAL = 'SET_EVENT_DETAIL_MODAL'


// WEBPACK FOOTER //
// ./src/types.js